import type { IconButtonProps } from '@mui/material/IconButton';
import type { Theme } from '@mui/material/styles';

import type { OnSurfaceFamily } from '../../onSurface';

import { ON_SURFACE_FAMILIES, onSurface } from '../../onSurface';

// ----------------------------------------------------------------------

export function iconButton(_theme: Theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        // A coloured icon button has no fill: its glyph IS the colour drawn on
        // the surface. MUI's default is `<color>.main`, picked to stand out as a
        // FILL under `contrastText` — 2.6:1 for `error` on a cream tenant, and
        // these carry the destructive actions (remove, delete). The on-surface
        // step is the same colour where it reads on whichever surface is
        // current. Only the ink moves: the hover wash MUI derives from `main`
        // is a fill and stays, and `default` / `inherit` keep their own ink.
        // The same rule the text and outlined Button already follow.
        root: ({ ownerState }: { ownerState: IconButtonProps }) =>
          ON_SURFACE_FAMILIES.includes(ownerState.color as OnSurfaceFamily)
            ? { color: onSurface[ownerState.color as OnSurfaceFamily] }
            : {},
      },
    },
  };
}
